import BigNumber from 'bignumber.js'
import numeral from 'numeral'
import { useMemo } from 'react'

import Rewards from '@/assets/rewards.png'
import WanPos from '@/assets/wanPos.png'
import { useLocalStorage } from '@/context/localstorage-context'
import { useQueryStatsInfo, useQueryTokenPrice } from '@/utils/queries'

import {
  Con,
  Data,
  Data1,
  Img,
  LineStyle,
  PosStatistics,
  PosTvlInUsd,
  PosTvlInUsdMedia,
  StatisticsAvg,
  StatisticsTitle,
  StatisticsTvl,
} from './Pos.module'

export default function PosStatisticsModule() {
  const { data: statsInfo } = useQueryStatsInfo()
  const { data: tokensPrice, isLoading: tokensPriceLoading } =
    useQueryTokenPrice()
  const { theme } = useLocalStorage()
  const isdark = useMemo(() => theme === 'dark', [theme])

  const WanPrice = useMemo(() => {
    if (!tokensPriceLoading && tokensPrice) {
      return tokensPrice.wanchain?.usd || '0'
    } else {
      return '0'
    }
  }, [tokensPrice, tokensPriceLoading])

  const posTvlInUsd = useMemo(() => {
    if (statsInfo && statsInfo.pos) {
      const posTvl = new BigNumber(statsInfo.pos.curTotalAmountRaw)
        .dividedBy(Math.pow(10, 18))
        .toString(10)
      const posTvlNumber = numeral(posTvl).value()
      const usdTvl = new BigNumber(WanPrice)
        .multipliedBy(posTvlNumber || '0')
        .toString()
      return numeral(usdTvl).format('0,0')
    } else {
      return 0
    }
  }, [WanPrice, statsInfo])

  const posTvl = useMemo(() => {
    if (statsInfo && statsInfo.pos) {
      return statsInfo.pos.curTotalAmount
    } else {
      return 0
    }
  }, [statsInfo])

  const posRewardRate = useMemo(() => {
    if (statsInfo && statsInfo.pos) {
      return statsInfo.pos.curReturnRate
    } else {
      return 0
    }
  }, [statsInfo])

  return (
    <PosStatistics className="bg-white dark:bg-common-1">
      <StatisticsTvl>
        <StatisticsTitle className="text-light-0 dark:text-dark-0">
          PoS TVL
          <PosTvlInUsd>
            <Data1>{posTvlInUsd} USD</Data1>
          </PosTvlInUsd>
        </StatisticsTitle>
        <Con>
          <Img src={WanPos} alt="WanPos" />
          <Data>
            <div className="text-light-111 dark:text-white">
              {posTvl} <Data1>WAN</Data1>
            </div>
            <PosTvlInUsdMedia>
              <Data1>{posTvlInUsd} USD</Data1>
            </PosTvlInUsdMedia>
          </Data>
        </Con>
      </StatisticsTvl>
      <LineStyle isdark={isdark} />
      <StatisticsAvg>
        <StatisticsTitle className="text-light-0 dark:text-dark-0">
          Average APR
        </StatisticsTitle>
        <Con>
          <Img src={Rewards} alt="Rewards" />
          <Data className="text-light-222 dark:text-white">
            {posRewardRate}
          </Data>
        </Con>
      </StatisticsAvg>
    </PosStatistics>
  )
}
